import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { ChartComponent, ChartType, GaugeInputs } from '@charts';
import { ChartCardComponent } from '../../chart-card/chart-card.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { ChartHeader } from '@charts';
import { IconComponent } from "@ui";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    ChartComponent,
    TranslocoDirective,
    ChartHeader,
    IconComponent
],
  selector: 'ui-rsabt-vtn-chart',
  template: `
    <ng-container *transloco="let t">
      <ui-chart-card class="h-full">
        <div class="flex flex-col justify-between h-full w-full">
          <chart-header
            [title]="t('CHARTS.VTN.TITLE')"
            [subtitle]="t('CHARTS.VTN.SUBTITLE')"
          />
          @if (vtnId() && vtnId().length > 0) {
            @if (gaugeInputs().value !== null && gaugeInputs().value !== undefined) {
              <chart
                class="mx-4"
                [type]="chartType()"
                [typeInputs]="gaugeInputs()"
              />
            }
            @else {
              <div class="flex justify-center items-center gap-x-2 py-2 px-6 bg-gray-100 rounded-full text-neutral-7 w-full">
                <ui-icon icon="api" class="text-xl" />
                {{ t('CHARTS.VTN.NO_DATA') }}
              </div>
            }
          } @else {
            <div class="flex justify-center items-center gap-x-2 py-2 px-6 bg-gray-100 rounded-full text-neutral-7 w-full">
              <ui-icon icon="disconnect" class="text-xl" />
              {{ t('CHARTS.VTN.NO_DEVICE') }}
            </div>
          }
          <div></div>
        </div>
      </ui-chart-card>
    </ng-container>
  `,
})
export class RsabtVtnChartComponent {
  vtnId = input.required<string>();
  gaugeInputs = input.required<GaugeInputs>();

  chartType = signal<ChartType>('gauge');
}
